import { useEffect, useRef, useState } from 'react';

type KeywordCampaignNamesCellProps = {
  names: string[];
};

export function KeywordCampaignNamesCell({ names }: KeywordCampaignNamesCellProps) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  const label = names.join(', ');

  useEffect(() => {
    if (!open) return;
    const onDoc = (mousedown: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(mousedown.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  if (names.length === 0) {
    return <span className="text-foreground-muted">-</span>;
  }

  const showSeeMore = names.length > 1;

  return (
    <div
      ref={rootRef}
      className="relative grid w-full min-w-0 grid-cols-[minmax(0,1fr)_auto] items-center gap-1"
    >
      <span className="min-w-0 truncate" title={label}>
        {label}
      </span>
      {showSeeMore ? (
        <>
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              setOpen((value) => !value);
            }}
            className="shrink-0 whitespace-nowrap text-xs font-medium text-brand hover:underline"
          >
            see more
          </button>
          {open ? (
            <div
              role="tooltip"
              className="absolute left-0 top-full z-30 col-span-2 mt-1 max-w-sm rounded-xl border border-border bg-surface px-2.5 py-2 text-xs leading-snug text-foreground shadow-lg"
            >
              {label}
            </div>
          ) : null}
        </>
      ) : null}
    </div>
  );
}
